import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from './core/components/loading/loading.component';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from './shared/components/services/app.layout.service';
import { LockerReservationService } from './features/user/services/locker-reservation.service';
import { AuthService } from './core/services/auth.service';
import { EventSubscriptionService } from './core/services/event-subscription.service';
import { CoreService } from './core/services/core.service';
import { EventsLockerService } from './features/user/services/events-locker.service';
import { LanguageService } from './core/services/language.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'easypick.no';

  constructor(
    private primengConfig: PrimeNGConfig, 
    private layoutService: LayoutService,
    private lockerReservationService: LockerReservationService,
    private authService: AuthService,
    private eventSubscriptionService: EventSubscriptionService,
    private coreService: CoreService,
    private eventsLockerService: EventsLockerService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    /* Call the important api's */
    this.coreService.preloadPrices().subscribe();
    this.coreService.preloadLocations().subscribe();
    this.coreService.preloadCountries().subscribe();

    /* Data Preloading */
    if (this.authService.isAuthenticated()) {
      this.lockerReservationService.preloadUserKeyData().subscribe();
    }
    
    /* Layout Configs */
    this.primengConfig.ripple = true; //enables core ripple functionality

    // Initialize theme from localStorage or default to 'dark'
    const savedTheme = localStorage.getItem('theme') || 'dark';
    this.layoutService.setTheme(savedTheme);

    // Initialize language from localStorage / browser, default to 'en'
    this.languageService.init();
  }

  ngOnDestroy(): void {
    /* This is needed to clear subscriptions to avoid memory leak */
    this.eventSubscriptionService.clearSubscriptions(); 

    this.eventsLockerService.clearCache();
  }
}
